var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13487_321447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "badgeStatus",
    d: "M55.0701 21.9436L67.8601 44.1003C74.2834 55.227 66.2534 69.137 53.4034 69.137H27.8234C14.9734 69.137 6.9434 55.227 13.3667 44.1003L26.1601 21.9436C32.5834 10.817 48.6467 10.817 55.0734 21.9436",
    fill: "#00D1D2",
    stroke: "#00D1D2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4568 55.3076L18.7634 69.1809",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8967 68.8545C19.9401 73.5912 23.2601 74.9612 23.2601 74.9612",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8967 68.8545C14.8267 71.4912 11.5 70.1345 11.5 70.1345",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7001 50.9974C33.0567 55.0007 28.4767 56.914 24.4734 55.2707C20.4701 53.6274 18.5567 49.0474 20.2001 45.044L29.1601 23.2207L43.6601 29.174L34.7001 51.0007V50.9974Z",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0066 51.5369C24.0699 50.7402 23.1399 48.5169 23.9366 46.5802L31.3633 28.4902",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.24 47.4365L59.2 61.8965",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1067 61.5566C62.8267 64.67 66.2934 63.7266 66.2934 63.7266",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1067 61.5566C57.4934 66.13 54.03 67.0866 54.03 67.0866",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2134 22.2503L39.3667 19.157L54.4834 15.0137L60.7167 37.767C61.86 41.9403 59.4034 46.2537 55.23 47.397C51.0567 48.5403 46.7434 46.0837 45.6 41.9103L45.1234 40.177",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.16 43.5034C52.14 44.0567 50.0467 42.8634 49.4933 40.8434L44.3267 21.9834",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3801 10.0173L43.8168 4.83398",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4968 11.337L50.7335 7.26367",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8769 10.6104L36.3735 6.05371",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13487_321447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4567,
    height: 71.7933,
    fill: "white",
    transform: "translate(10.6667 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialite);
export default __webpack_public_path__ + "static/media/socialite.5fc00fc62b7408d4730030211e3b7de6.svg";
export { ForwardRef as ReactComponent };